module.exports = __webpack_public_path__ + "static/GTSuperDisplay-Regular-9272f99adfb8d7f93123a7179c03bf49.eot";